// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  serversIpAddress: 'http://localhost:3080/',
  staticAssetsServer: 'http://localhost:3080/',
  loginImagePath: 'https://rik.fra1.digitaloceanspaces.com/logo-cover-images/parlament-login.png',
  coverImagePath1: '/assets/images/Dashboard-eng.png',
  coverImagePath2: '/assets/images/Dashboard-lat.png',
  coverImagePath3: '/assets/images/Dashboard-cir.png',
  coverImagePathMobile1: '/assets/images/Dashboard-eng.png',
  coverImagePathMobile2: '/assets/images/Dashboard-lat.png',
  coverImagePathMobile3: '/assets/images/Dashboard-cir.png',
  loginImagePath1: '/assets/images/LOGO-RGZ-eng.svg',
  loginImagePath2: '/assets/images/LOGO-RGZ-lat.svg',
  loginImagePath3: '/assets/images/LOGO-RGZ-cir.svg',
  //recaptchaKey: '6LerkcwqAAAAAK2IBlgL9SAQCeRoo41Ss_YxkFPX',
  recaptchaKey: '6Ld4mNwqAAAAAI_0fZMIVEFkO_p8162U7tELIlzL',
  registrationImagePath: 'https://rik.fra1.digitaloceanspaces.com/logo-cover-images/parlament-login.png',
  termsLogoPath: 'https://rik.fra1.digitaloceanspaces.com/logo-cover-images/parlament-login.png'
};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
